import { ThemeProvider } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from 'react-query'
import theme from './theme'
import LocationsList from './containers/LocationsList'

const queryClient = new QueryClient()

const App = (): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <LocationsList />
    </ThemeProvider>
  </QueryClientProvider>
)

export default App
